module.exports = __webpack_public_path__ + "img/renz_img2.4ac886b6.jpg";